<div class="text-end">
  @if (order) {
    <button mat-stroked-button (click)="printAllLabels()" class="me-2">
      <mat-icon>print</mat-icon> Print all labels
    </button>
  }
</div>

<table mat-table matSort [dataSource]="dataSource" class="order-list">
  <ng-container matColumnDef="pack_size">
    <th mat-header-cell *matHeaderCellDef>Pack size</th>
    <td mat-cell *matCellDef="let item"> {{item.medicineDosagePackageType.contained_quantity}} </td>
  </ng-container>

  <ng-container matColumnDef="dosage">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let item"> {{ item.medicineDosagePackageType.medicine_dosage_type.additional_information }} </td>
  </ng-container>

  <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef>Price</th>
    <td mat-cell *matCellDef="let item"> {{ item.medicineDosagePackageType.price | currency:'ZAR':'symbol-narrow' }} </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
    <td mat-cell *matCellDef="let item">

      <div class="row">

        <div class="col-6">

          <button color="warn" (click)="deleteOrderItem(item)" mat-stroked-button>
            <mat-icon>delete_outline</mat-icon> Remove
          </button>

        </div>


        <div class="col-6 text-end">

          @if (order) {
            <button mat-stroked-button (click)="printLabels([item])" class="me-2">
              <mat-icon>print</mat-icon> Print labels
            </button>
          }

        </div>

      </div>

    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>